export default __webpack_public_path__ + "static/media/example.ac0a0792.png";